// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2_yx1","messages":"Chat_messages__2YdGd","dateDivider":"Chat_dateDivider__2vKKW"};